<app-content-container
  [isLoading]="(patientMedicalHistoryState$ | async)?.isLoading || (healthConditionsState$ | async)?.isLoading"
  [error]="(patientMedicalHistoryState$ | async)?.error || (healthConditionsState$ | async)?.error"
>
  <div class="flex align-items-center justify-content-between flex-wrap">
    <h2 class="my-1">Medical History</h2>
    <button
      *ngIf="!editMode"
      pButton
      type="button"
      label="Edit"
      icon="mi-round mi-edit"
      class="p-button-text p-button-sm mr-1"
      (click)="startEdit()"
      appClickEvent
      eventName="profile_edit_patient_medical_history"
      data-cy="edit-patient-medical-history-button"
    ></button>
    <button
      *ngIf="editMode"
      pButton
      type="button"
      label="Cancel editing"
      icon="mi-round mi-close"
      class="p-button-text p-button-sm mr-1"
      (click)="onCancel()"
      appClickEvent
      eventName="profile_cancel_edit_patient_medical_history"
      data-cy="cancel-edit-patient-medical-history-button"
    ></button>
  </div>
  <p-divider></p-divider>
  <div *ngIf="!editMode">
    <h3 class="m-0">Medications you are taking</h3>
    <div data-cy="profile-medications-list">
      <p *ngFor="let medication of (patientMedicalHistoryStrings$ | async)?.medicationsStrArray" class="p2 my-2">
        {{ medication }}
      </p>
    </div>
    <p-divider class="my-5"></p-divider>
    <h3 class="m-0">Medical Condition</h3>
    <p class="p2 my-2" data-cy="profile-medical-conditions-list">
      {{ (patientMedicalHistoryStrings$ | async)?.medicalConditionsStr }}
    </p>
    <p-divider class="my-5"></p-divider>
    <h3 class="m-0">Allergy Conditions</h3>
    <p class="p2 my-2" data-cy="profile-allergy-conditions-list">
      {{ (patientMedicalHistoryStrings$ | async)?.allergyConditionsStr }}
    </p>
  </div>
  <div *ngIf="editMode">
    <app-message
      *ngIf="showError && (updateMedicalHistoryState$ | async)?.error"
      severity="error"
      [noMargin]="false"
      data-cy="update-medical-history-error-message"
    >
      {{
        (updateMedicalHistoryState$ | async)?.error?.uiMessage || (updateMedicalHistoryState$ | async)?.error?.message
      }}
    </app-message>
    <form [formGroup]="medicalHistoryForm" (ngSubmit)="onSubmit()" data-cy="medical-history-form">
      <h3 class="mt-0 mb-3">Medications you are taking</h3>
      <p class="p2 mt-0 mb-5 text-black-400">
        Tell us about any medications, herbal supplements or vitamins you are taking
      </p>
      <div class="w-12 md:w-10 lg:w-8 xl:w-6">
        <app-form-field
          [control]="asFormControl(medicalHistoryForm.get('medications'))"
          name="medications"
          type="autocomplete"
          label="My medicines, herbal supplements and vitamins"
          [options]="medicationResults"
          [completeMethod]="this.onSearchMedications.bind(this)"
          [isLoading]="this.isSearchingMedications"
        >
        </app-form-field>
      </div>
      <p-divider></p-divider>
      <h3 class="mt-0 mb-3">Medical Conditions</h3>
      <p class="p2 mt-0 mb-5 text-black-400">
        Tell us about any medical conditions you have so we can check possible risks with your medicines
      </p>
      <div class="w-12 md:w-10 lg:w-8 xl:w-6">
        <app-form-field
          [control]="asFormControl(medicalHistoryForm.get('medicalConditions'))"
          name="medicalConditions"
          [options]="medicalConditionOptions"
          label="Medical Conditions"
          type="multiselect"
        ></app-form-field>
      </div>
      <p-divider></p-divider>
      <h3 class="mt-0 mb-3">Allergy Conditions</h3>
      <p class="p2 mt-0 mb-5 text-black-400">
        Tell us about any allergies you have so we can check possible risks with your medicines
      </p>
      <div class="w-12 md:w-10 lg:w-8 xl:w-6">
        <app-form-field
          [control]="asFormControl(medicalHistoryForm.get('allergies'))"
          name="allergies"
          [options]="allergyOptions"
          label="Allergies"
          type="multiselect"
        ></app-form-field>
      </div>
      <div class="grid">
        <div class="col-12 lg:col-4 lg:w-4 xl:w-3">
          <app-form-footer
            [submitLabel]="(updateMedicalHistoryState$ | async)?.isLoading ? 'Saving...' : 'Save'"
            cancelLabel="Cancel"
            [handleCancel]="onCancel.bind(this)"
            [disabled]="(updateMedicalHistoryState$ | async)?.isLoading"
            [small]="true"
            [justifyLeft]="true"
          ></app-form-footer>
        </div>
        <div class="col-12 lg:col-8">
          Please note that any changes you make to your medical profile may take up to 2 business days to update in our
          system. If you have an order scheduled to ship in the next week, please contact the pharmacy at (888) 308-8882
          to update your medical profile.
        </div>
      </div>
    </form>
  </div>
</app-content-container>
